<template>
  <div>
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="模板名称">
            <a-input v-model="searchForm.name" allowClear placeholder="请输入模板名称" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="模板类型">
            <a-select v-model="searchForm.template_type" allowClear show-search option-filter-prop="children" placeholder="请选择模板类型" style="width: 100%">
              <a-select-option v-for="item in TEMPLATE_TYPE" :key="item.id" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="模板状态">
            <a-select v-model="searchForm.state" allowClear show-search option-filter-prop="children" placeholder="请选择模板状态" style="width: 100%">
              <a-select-option v-for="item in TEMPLATE_STATE" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="模板内字段名">
            <a-input v-model="searchForm.field_name" allowClear placeholder="请输入字段名称" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <a-button type="primary" icon="plus-circle" @click="$router.push('/template/edit')">添加模板</a-button>
      <div>
        <a-button type="primary" icon="search" style="margin-right:18px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :columns="columns" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="org" slot-scope="text">
        <a-tag color="blue">{{ text }}</a-tag>
      </template>
      <template slot="state" slot-scope="text">
        <span v-if="text === 1">{{ showName('TEMPLATE_STATE', text) }}</span>
        <span v-else style="color:red;">{{ showName('TEMPLATE_STATE', text) }}</span>
      </template>
      <template slot="operator" slot-scope="text, record">
        <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
        <a-button size="small" type="link" @click="handleTableCommand('state', record)">{{ record.state === 1 ? '禁用' : '启用' }}</a-button>
        <a-button size="small" type="link" @click="handleTableCommand('delete', record)">删除</a-button>
      </template>
    </a-table>
  </div>
</template>
<script>
import { reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { strategyCommand } from './business/tableLogic'
import { searchForm, columns } from './business/constant'
import pagination from '@/composables/pagination'
import compuedFun from '../../computed/'
import api from '@/api/'

export default {
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      platformList: [], // 发布平台
      searchForm: { ...searchForm }
    })

    onMounted(() => {
      methods.getPlatform()
      state.searchForm = _this.SEARCH_FORM
      methods.getList()
    })
    onUnmounted(async () => {
      if (!_this.$route.params.id) {
        _this.SET_SEARCH[0]({})
      }
    })

    const methods = {
      search() {
        _this.pagination.current = 1
        _this.SET_SEARCH[0](state.searchForm)
        this.getList()
      },

      async getList() {
        _this.loading = true
        const res = await api.listTemplate({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { template, pagination } = res.data
        _this.data = template
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      // 获取发布平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },

      // 清除
      handleClear() {
        state.searchForm = { ...searchForm }
        this.search()
      },

      // 表格操作
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods
    }
  }
}
</script>
<style lang='less'>
</style>
